import React, { useState, useEffect,forwardRef, useImperativeHandle} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { FormControl, InputLabel, Select, Snackbar } from '@material-ui/core';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import MuiAlert from '@material-ui/lab/Alert';
import { HttpService } from '../../apiAuthorization/httpService';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
};

const useStyles = makeStyles(theme => ({
    root: {
        '& > *': {
            margin: '7px 0px',
            width: '100%'
        }
    },
    button: {
        width: '15%',
        float: 'right'
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        maxWidth: 300
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff'
    },
    mb10: {
        marginBottom: "10px"
    },
    mb5: {
        marginBottom: "5px"
    }
}));


const EnvironmentalChecklistAdd = forwardRef((props, ref) => {
    const classes = useStyles();
    const { close, onDisableWithStyle } = props;
    const [suicideEnvironmentalChecklistDto, setSuicideEnvironmentalChecklistDto] = useState([]);
    const [openError, setOpenError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const [timeOfChecklists] = useState([
        { Name: "A.M." },
        { Name: "P.M." },
        { Name: "Overnight" }
    ]);

    const [mealsChecklists] = useState([
        { Name: "Breakfast " },
        { Name: "Lunch" },
        { Name: "Dinner" },
        { Name: "N/A" }
    ]);

    const [suicideEnvironmentalChecklist, setSuicideEnvironmentalChecklist] = useState([
        { Id: 1, Checked: false, Text: "No Sharp Items." },
        { Id: 2, Checked: false, Text: "No Personal Items." },
        { Id: 3, Checked: false, Text: "Call Light, Medical Equipment. (IV Lines, Medical Devices, O2, Telemetry/NGT, etc.)" },
        { Id: 4, Checked: false, Text: "All Belongings bring in by visitors are checked by Nurse." },
    ]);

    const closeErrorSnackbar = () => {
        setOpenError(false);
    };

    const onTCRChanged = (event) => {
        setSuicideEnvironmentalChecklistDto({ ...suicideEnvironmentalChecklistDto, TimeOfChecklist: event.target.value });
    };

    const onSEMChanged = (event) => {
        setSuicideEnvironmentalChecklistDto({ ...suicideEnvironmentalChecklistDto, Meals: event.target.value });
    };

    const onSuicideEnvironmentalValueChange = (event, item) => {
        var obj = JSON.parse(JSON.stringify(suicideEnvironmentalChecklist));

        obj.forEach((i) => {
            if (i.Id === item.Id) {
                i.Checked = event.target.checked;
            }
        });
        setSuicideEnvironmentalChecklist(obj);
    }

    const disabledSuicideEnvironmentalChecklist = () => {

        var disabled = false;
        var dto = suicideEnvironmentalChecklistDto;

        if (!dto) {
            return false;
        }
  
        if (!dto.TimeOfChecklist || dto.TimeOfChecklist === "0") {
            disabled = true;
        }
 
        if (!dto.Meals || dto.Meals === "0") {
            disabled = true;
        }

        suicideEnvironmentalChecklist.forEach((item) => {
            if (!item.Checked) {
                disabled = true;
            }
        });

        onDisableWithStyle(disabled);
        return disabled;

    };


    const saveSuicideEnvironmentalChecklist = () => {

        if (disabledSuicideEnvironmentalChecklist()) {
            setErrorMessage("If any issues are not able to be resolved, please contact manager");
            setOpenError(true);
            return;
        }

        var dto = suicideEnvironmentalChecklistDto;
        dto.OtherJson = JSON.stringify(suicideEnvironmentalChecklist);

        HttpService.post('/PatientSitting/SaveSuicideEnvironmentalChecklist',
            dto
        )
            .then((result) => {
                close();
            },
                (error) => {
                      //This is intentional
                });
    };

    useImperativeHandle(ref, () => {
        return {
            save: saveSuicideEnvironmentalChecklist
        };
    });

    useEffect(() => {
        onDisableWithStyle(true);
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        disabledSuicideEnvironmentalChecklist();
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [suicideEnvironmentalChecklist, suicideEnvironmentalChecklistDto]);

    return (
        <div>
            <Snackbar open={openError} autoHideDuration={3000} onClose={closeErrorSnackbar} style={{ height: "100%" }}>
                <Alert onClose={closeErrorSnackbar} severity="error">
                    {errorMessage}
                </Alert>
            </Snackbar>
            <FormControl variant="outlined" margin="dense" fullWidth className={classes.ddl}>
                <InputLabel htmlFor="IssueType">Time of Checklist Review</InputLabel>
                <Select
                    native
                    label="Time of Checklist Review"
                    size="small"
                    value={suicideEnvironmentalChecklistDto.TimeOfChecklist}
                    onChange={(e) => onTCRChanged(e)}
                >
                    <option aria-label="None" key="0" value="0" />
                    {
                        timeOfChecklists.map((option, key) => {
                            return <option key={option.Name} value={option.Name} label={option.Name} >{option.Name}</option>;
                        })
                    }
                </Select>
            </FormControl>
            <FormControl variant="outlined" margin="dense" fullWidth className={classes.ddl}>
                <InputLabel htmlFor="IssueType">All meals served on a paper tray, with plastic utensils and no glass</InputLabel>
                <Select
                    native
                    label="All meals served on a paper tray, with plastic utensils and no glass"
                    size="small"
                    value={suicideEnvironmentalChecklistDto.Meals}
                    onChange={(e) => onSEMChanged(e)}
                >
                    <option aria-label="None" key="0" value="0" />
                    {
                        mealsChecklists.map((option, key) => {
                            return <option key={option.Name} value={option.Name} label={option.Name} >{option.Name}</option>;
                        })
                    }
                </Select>
            </FormControl>
            <FormGroup style={{ display: "flex" }}>
                {
                    suicideEnvironmentalChecklist.map((item) => {
                        return (
                            <FormControlLabel
                                key={item.Id}
                                control={
                                    <Checkbox
                                        checked={item.Checked}
                                        onChange={(e) => { onSuicideEnvironmentalValueChange(e, item); }}
                                        value="Checked"
                                    />
                                }
                                label={item.Text}
                                style={{ color: '#4183c4' }}
                            />
                        )
                    })
                }
            </FormGroup>
        </div>
    );
});
export default EnvironmentalChecklistAdd;